import { render, staticRenderFns } from "./modalInfos.vue?vue&type=template&id=60c53700&scoped=true&"
import script from "./modalInfos.vue?vue&type=script&lang=js&"
export * from "./modalInfos.vue?vue&type=script&lang=js&"
import style0 from "./modalInfos.vue?vue&type=style&index=0&id=60c53700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c53700",
  null
  
)

export default component.exports